import React from "react"
import { Card, CardHeader, CardTitle, CardBody } from "reactstrap"
import Swiper from "react-id-swiper"
import 'swiper/swiper.scss'

import { inject, observer } from 'mobx-react';

@observer
class Thumb extends React.Component {
  render() {
    const slide = this.props.slide
    const active = this.props.active
    
    const slideComp = slide.type === 'LINK' ? (<div className={`${active ? "thumb active" : "thumb"}`}>
    <img className={` ${
      slide.animate
      ? `animated ${slide.animate}`
        : ""
      }`} 
      src={slide.content} /> 
      
      </div>)
      : 
      (
        <div className="thumb" dangerouslySetInnerHTML={{__html: slide.content}} />
      );
    return <React.Fragment>
          {slideComp}
          </React.Fragment>
  }
}
export default Thumb;
